import {
  RangeSearchParams,
  SearchModality,
  SearchParams,
  SearchType,
  SearchValue,
  ValuesSearchParams,
} from '../../types';

/** Since the SearchParams do get stored in localStorage, there should be support for searchParams v1 and v2 simultaniously. */
export const searchParamsBackwardsCompatibility = (historic: SearchParams) => {
  if ((historic?.searchModality as SearchModality | 'stringArray') === 'stringArray')
    historic.searchModality = 'multiple';
  if ((historic?.searchType as SearchType | 'trainAndRollingStock') === 'trainAndRollingStock') {
    const valueLength = (value: SearchValue) => (Array.isArray(value) ? String(value[0]).length : String(value).length);
    // Adjust the historic items with searchType trainAndRollingStock. Assume train or rollingstock on number of digits
    historic.searchType =
      valueLength((historic as ValuesSearchParams)?.searchValue) === 4 ||
      (String((historic as RangeSearchParams)?.fromValue).length === 4 &&
        String((historic as RangeSearchParams)?.toValue).length === 4)
        ? 'rollingStock'
        : 'train';
  }
  return historic;
};
